module.exports = __webpack_public_path__ + "img/averageCop2.da67623d.png";